module.exports = __webpack_public_path__ + "static/media/2-fr.0ce5ad08.png";